<!--  COMPONENT IS OBSOLETE AND CAN BE REMOVED ONCE THERE ARE NO ACTIVE OLD REQUEST OBJECTS  -->
@if (editRequest$ | async; as request ) {
  <div class="themeable {{profile.theme}} modal-wrapper">
    <div class="modal-header">
      <h4 tabindex="0" ngbAutofocus class="modal-title">
        Update Request
      </h4>
      @if (transferCredits.saveStatus$ | async; as saveText) {
        <sub class="ms-1 mt-3" [ngClass]="{'text-success':!!!transferCredits.hasSaveError,'text-danger':!!transferCredits.hasSaveError}">
          <i class="far fa-save"></i>&nbsp;{{saveText}}
        </sub>
      }
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body mb-2">
      <app-credit-request [request]="request"></app-credit-request>
    </div>
  </div>
} @else {
  @if (error) {
    <div class="{{profile.theme}}">
      <div class="modal-header">
        <h4 tabindex="0" ngbAutofocus class="modal-title">
          Oops - A Problem Occurred!
        </h4>
        @if (transferCredits.saveStatus$ | async; as saveText) {
          <sub class="ms-1 mt-3" [ngClass]="{'text-success':!!!transferCredits.hasSaveError,'text-danger':!!transferCredits.hasSaveError}">
            <i class="far fa-save"></i>&nbsp;{{saveText}}
          </sub>
        }
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        </button>
      </div>
      <div class="modal-body mb-2">
        @if (!!error && !!!errorUnauthorized) {
          <div><p>There was a problem. Please try again.</p> <p>If the problem persists, please contact the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk&#64;kenan-flagler.unc.edu</a></p></div>
        }
        @if (!!error && !!errorUnauthorized) {
          <div><p>You do not have permission to add a request.</p> <p>If you need assistance, please contact the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk&#64;kenan-flagler.unc.edu</a></p></div>
        }
      </div>
    </div>
  } @else {
    <div class="{{profile.theme}}">
      <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        </button>
      </div>
      <div class="modal-body mb-2">
        <div class="col-12 text-center">
          <h4>Loading Request</h4>
          <i class="fas fa-circle-notch fa-spin"></i>
        </div>
      </div>
    </div>
  }
}
